import PortailSettingController from './portail.setting.controller';

export default {
    controller: PortailSettingController,
    template: require('./portail.setting.tpl.html')
};
